module.exports = __webpack_public_path__ + "img/email.e6956db2.svg";